import React from 'react';
import './Footer.css'
import twitter from '../../assets/images/twitter.svg'
import github from '../../assets/images/github.svg'
import linkedin from '../../assets/images/linkedin.svg'

const Footer = () => {

    return (
        <div className="footer">
            <a href="/" rel="noreferrer" className="footer-title">No Wires</a>
            <a href="https://www.privacypolicygenerator.info/live.php?token=IkZMcZ1BKT692DItmD0Y2iqCwsZmpGEg" rel="noreferrer"
            target="_blank" className="terms-conditions"> Privacy policy </a>
            <div className="social-media-icons">
                <a href="https://www.linkedin.com/in/jayanthsaikiran/" rel="noreferrer" target="_blank"><img src={linkedin} alt="linkedin" /></a>
                <a href="https://www.github.com/jayanthsaikiran/" rel="noreferrer" target="_blank"><img src={github} alt="github" /></a>
                <a href="https://twitter.com/jayanthsaikiran" rel="noreferrer" target="_blank"><img src={twitter} alt="twitter"  /></a>
            </div>
        </div>
    )
}

export default Footer;